var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect, useCallback } from "react";
import { InputAdornment } from "@material-ui/core";
import FTLTextField from "./FTLTextField";
import FTLIconButton from "../buttons/FTLIconButton";
import { ClearIcon, SearchIcon } from "../icons";
export default (_a) => {
    var { onChange, disabled = false, value = "", iconSize = "default" } = _a, otherProps = __rest(_a, ["onChange", "disabled", "value", "iconSize"]);
    const [valueState, setValue] = useState(value);
    useEffect(() => {
        onChange && onChange(valueState);
    }, [valueState]);
    const resetValue = useCallback(() => setValue(""), []);
    return (React.createElement(FTLTextField, Object.assign({ type: "text", size: "small", value: valueState, onChange: (e) => {
            setValue(e.target.value);
        }, disabled: disabled, InputProps: {
            endAdornment: (React.createElement(InputAdornment, { position: "end" },
                React.createElement(FTLIconButton, { disableRipple: true, tabIndex: -1, size: "small", disabled: disabled, color: valueState.length === 0 ? undefined : "tertiary" }, valueState.length === 0 ? (React.createElement(SearchIcon, null)) : (React.createElement(ClearIcon, { onClick: () => {
                        resetValue();
                    }, sizeRatio: iconSize === "small" ? 0.83 : 1 }))))),
        } }, otherProps)));
};
//# sourceMappingURL=FTLSearchField.js.map